export const aiGeneratedJobs = [
  {
    id: 'job-001',
    title: 'Kitchen Renovation - Full Remodel',
    tradeType: 'Carpentry',
    location: 'Bondi, NSW 2026',
    aiEstimatedBudget: '$8,500 - $12,000',
    urgency: 'High',
    postedTime: '2 hours ago',
    description: 'Complete kitchen renovation including cabinet installation, benchtop replacement, and tiling. Client has provided detailed measurements and material preferences.',
    scope: ['Remove existing cabinets', 'Install new custom cabinetry', 'Benchtop installation', 'Splashback tiling', 'Plumbing connections'],
    clientRating: 4.8,
    jobsPosted: 12,
    verified: true
  },
  {
    id: 'job-002',
    title: 'Emergency Electrical Fault - Urgent',
    tradeType: 'Electrical',
    location: 'Parramatta, NSW 2150',
    aiEstimatedBudget: '$350 - $600',
    urgency: 'Urgent',
    postedTime: '45 minutes ago',
    description: 'Power outage in main bedroom and living room. Circuit breaker keeps tripping. Need licensed electrician ASAP.',
    scope: ['Diagnose electrical fault', 'Repair or replace faulty wiring', 'Test all circuits', 'Safety certificate'],
    clientRating: 4.9,
    jobsPosted: 5,
    verified: true
  },
  {
    id: 'job-003',
    title: 'Bathroom Waterproofing & Tiling',
    tradeType: 'Tiling',
    location: 'Manly, NSW 2095',
    aiEstimatedBudget: '$4,200 - $6,800',
    urgency: 'Medium',
    postedTime: '5 hours ago',
    description: 'Full bathroom waterproofing and floor-to-ceiling tiling. 8sqm total area. Premium porcelain tiles already purchased.',
    scope: ['Waterproofing membrane application', 'Floor tiling (4sqm)', 'Wall tiling (12sqm)', 'Grout and seal', 'Final inspection'],
    clientRating: 5.0,
    jobsPosted: 8,
    verified: true
  },
  {
    id: 'job-004',
    title: 'Roof Leak Repair - Terracotta Tiles',
    tradeType: 'Roofing',
    location: 'Chatswood, NSW 2067',
    aiEstimatedBudget: '$1,800 - $3,200',
    urgency: 'High',
    postedTime: '1 hour ago',
    description: 'Water leaking through ceiling in master bedroom during heavy rain. Terracotta tile roof, approximately 15 years old.',
    scope: ['Locate leak source', 'Replace damaged tiles', 'Check and repair flashing', 'Gutter inspection', '12-month warranty'],
    clientRating: 4.7,
    jobsPosted: 3,
    verified: false
  },
  {
    id: 'job-005',
    title: 'Ducted Air Conditioning Installation',
    tradeType: 'HVAC',
    location: 'Castle Hill, NSW 2154',
    aiEstimatedBudget: '$9,500 - $14,000',
    urgency: 'Low',
    postedTime: '1 day ago',
    description: 'Install ducted air conditioning system in 4-bedroom house. Roof space accessible. Looking for energy-efficient system with zone control.',
    scope: ['Site assessment', 'System design and sizing', 'Ducting installation', 'Indoor and outdoor unit installation', 'Electrical connection', 'Commissioning and testing'],
    clientRating: 4.6,
    jobsPosted: 15,
    verified: true
  },
  {
    id: 'job-006',
    title: 'Deck Construction - Merbau Timber',
    tradeType: 'Carpentry',
    location: 'Cronulla, NSW 2230',
    aiEstimatedBudget: '$12,000 - $18,000',
    urgency: 'Medium',
    postedTime: '3 hours ago',
    description: 'Build elevated timber deck (6m x 4m) with stairs and handrails. Merbau timber preferred. Council approval already obtained.',
    scope: ['Foundation and frame construction', 'Decking board installation', 'Stair construction', 'Handrail and balustrade', 'Timber treatment and finishing'],
    clientRating: 4.9,
    jobsPosted: 6,
    verified: true
  },
  {
    id: 'job-007',
    title: 'Hot Water System Replacement',
    tradeType: 'Plumbing',
    location: 'Penrith, NSW 2750',
    aiEstimatedBudget: '$2,200 - $3,800',
    urgency: 'Urgent',
    postedTime: '30 minutes ago',
    description: 'Gas hot water system failed. Need replacement with energy-efficient model. 4-person household.',
    scope: ['Remove old system', 'Install new gas hot water unit', 'Gas line connection', 'Compliance certificate', 'Test and commission'],
    clientRating: 4.8,
    jobsPosted: 9,
    verified: true
  },
  {
    id: 'job-008',
    title: 'Exterior House Painting - 3 Bedroom',
    tradeType: 'Painting',
    location: 'Ryde, NSW 2112',
    aiEstimatedBudget: '$6,500 - $9,500',
    urgency: 'Low',
    postedTime: '2 days ago',
    description: 'Full exterior repaint of weatherboard house. Surface preparation required. Premium weather-resistant paint.',
    scope: ['Pressure washing', 'Surface preparation and repairs', 'Primer application', 'Two coats premium exterior paint', 'Trim and detail work'],
    clientRating: 4.7,
    jobsPosted: 4,
    verified: false
  }
];